import {
  boldFont,
  borderRadius,
  customButtonStyle,
  infoTextColor,
  primaryBackgroundColor,
  getCurrentAccentColor,
  getCurrentAccentTextColor,
} from "../../../utils/styles";
import { makeStyles, Theme } from "@material-ui/core";

const switchButtonsStyles = makeStyles(
  (theme: Theme) => ({
    buttonsContainer: {
      display: "flex",
      flex: 1,
      backgroundColor: primaryBackgroundColor,
      borderRadius: borderRadius,
      alignItems: "center",
      fontWeight: "bolder",
      width: "fit-content",
    },
    activeButton: {
      ...customButtonStyle,
      ...boldFont,
      display: "flex",
      flex: 1,
      width: "fit-content",
      padding: "8px 25px",
      backgroundColor: getCurrentAccentColor(),
      color: getCurrentAccentTextColor(),
      fontWeight: "bolder",
      "&:hover": {
        backgroundColor: getCurrentAccentColor(),
        color: getCurrentAccentTextColor(),
      },
    },
    inactiveButton: {
      ...customButtonStyle,
      ...boldFont,
      display: "flex",
      flex: 1,
      padding: "8px 25px",
      width: "fit-content",
      backgroundColor: "transparent",
      color: infoTextColor,
      fontWeight: "bolder",
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
  }),
  { index: 1 }
);

export default switchButtonsStyles;
